import React from "react";
//import unionIcon from "../../assets/images/Union.svg";
import VoucherInput from "./Voucher";
import { Elements, CardNumberElement } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import PaymentTerms from "./PaymentTerms";
import WalletPayment from "./WalletPayment";
import { Stripe } from "@stripe/stripe-js";
//import { FaPlus, FaMinus } from "react-icons/fa";
import { useTranslation } from "react-i18next";

// Define types for props
/*
interface Upsell {
  id: string;
  code: string;
  price: number;
  type: string;
  excluded_properties?: string;
  is_multi_quantity?: number;
  quantity_limit?: number;
}

interface UpsellValues {
  [key: string]: { value: number };
}
*/

interface StepTwoComponentProps {
  step?: number;
  //upsells?: Upsell[];
  params?: { id: string };
  //upsellValues?: UpsellValues;
  formatMoney?: (amount: number, decimals: number, currency: string) => string;
  currency?: string;
  //increaseUpsellValue?: (upsell: Upsell) => void;
  //decreaseUpsellValue?: (upsell: Upsell) => void;
  voucherData?: any;
  voucherCode?: string;
  setVoucherCode?: (code: string) => void;
  setVoucherData?: (data: any) => void;
  stripe?: Stripe | null;
  formRef: React.RefObject<HTMLFormElement>; // Declare a new prop for formRef
  setElements?: (elements: any | null) => void;
  setError?: (error: string | null) => void;
  setStripe?: (stripe: Stripe | null) => void;
  error?: string | null;
  //   handleSubmit?: (event: React.FormEvent) => void;
  handleSubmit: (stripe: any, elements: any) => Promise<void>; // Define a prop for the handleSubmit function
  isChecked?: boolean;
  setChecked?: (checked: boolean) => void;
  errorMessage?: string | string[];
  // Props of the Apple Pay and Google Pay buttons, without them until the
  // price from the server is known.
  walletProps?: any;
  // Paying waits for the price from the server.
  paymentReady?: boolean;
  // Loads the price again after it could not be loaded.
  onRetryPrice?: (() => void) | null;
  submitHandler: () => Promise<void>; // Define a prop for the handleSubmit function
  isLoading?: boolean;
  onCardFieldChange?: (elementType: string, state: { empty: boolean; complete: boolean }) => void;
  formError?: Record<string, string[]>;
}

const StepTwoComponent: React.FC<StepTwoComponentProps> = ({
  step,
  //upsells = [],
  //params,
  //upsellValues = {},
  //formatMoney,
  //currency = "",
  //increaseUpsellValue,
  //decreaseUpsellValue,
  voucherData,
  voucherCode,
  setVoucherCode,
  setVoucherData,
  stripe,
  formRef,
  setElements,
  setError,
  setStripe,
  error,
  handleSubmit,
  isChecked,
  setChecked,
  errorMessage = [],
  walletProps = null,
  paymentReady = true,
  onRetryPrice = null,
  isLoading,
  submitHandler,
  onCardFieldChange,
  formError = {},
}) => {
  const { t } = useTranslation();
  return (
    <>
      {step === 2 && (
        <>
          {/*
          <div className='roomAcceriesWrap'>
            <header className='headingHead'>
              <h2>{t("additional_item")}</h2>
            </header>
            
            <ul className='asseriesDetails listUnstyled'>
              {upsells
                .filter((ups) => {
                  if (ups && ups.excluded_properties) {
                    if (typeof ups.excluded_properties === "string") {
                      return !ups.excluded_properties
                        .split(",")
                        .includes(params?.id || "");
                    }
                    return true;
                  }
                  return true;
                })
                .map((ups, i) => (
                  <li key={i}>
                    <div className='asessDescrWrap'>
                      <div className='assesTextDescr'>
                        <span className='icnAsses'>
                          <img src={unionIcon} alt='imageDescription' />
                        </span>
                        <div className='textWrap'>
                          <h3>{ups.code}</h3>
                          <p>
                            <strong>
                              {formatMoney
                                ? formatMoney(ups.price, 2, currency)
                                : `${ups.price} ${currency}`}{" "}
                              /{" "}
                            </strong>{" "}
                            {t("per")} {t(ups.type)}
                          </p>
                        </div>
                      </div>
                      <div className='quantity'>
                        <input
                          name={`val-${i}`}
                          type='number'
                          min='1'
                          value={upsellValues[ups.id]?.value || 0}
                          readOnly
                        />
                        <div className='quantity-nav'>
                          <div
                            className='quantity-button quantity-plus d-flex align-items-center justify-content-center'
                            onClick={() => {
                              if (
                                upsellValues[ups.id]?.value >=
                                (ups.is_multi_quantity === 1
                                  ? ups.quantity_limit || 1
                                  : 1)
                              ) {
                                return;
                              } else {
                                increaseUpsellValue?.(ups);
                              }
                            }}
                          >
                            <FaPlus />
                          </div>
                          <div
                            className='quantity-button quantity-minus d-flex align-items-center justify-content-center'
                            onClick={() => {
                              if (upsellValues[ups.id]?.value > 0) {
                                decreaseUpsellValue?.(ups);
                              }
                            }}
                          >
                            <FaMinus />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
          */}
          
          <header className='headingHead'>
            <h2>{t("payment")}</h2>
          </header>

          <VoucherInput
            voucherCode={voucherCode || ""}
            setVoucherCode={setVoucherCode || (() => {})}
            setVoucherData={setVoucherData || (() => {})}
          />

          <PaymentTerms
            isChecked={isChecked || false}
            setChecked={setChecked || (() => {})}
            error={formError.terms?.[0]}
          />

          {walletProps && <WalletPayment stripe={stripe} {...walletProps} />}

          <Elements stripe={stripe || null}>
            <CheckoutForm
              formRef={formRef}
              setElements={setElements || (() => {})}
              setError={setError || (() => {})}
              setStripe={setStripe || (() => {})}
              error={error || null}
              handleSubmit={handleSubmit || (() => {})}
              submitHandler={submitHandler}
              isLoading={isLoading || false}
              disabled={!paymentReady}
              onCardFieldChange={onCardFieldChange}
              formError={formError}
            />
          </Elements>

          {(Array.isArray(errorMessage) ? errorMessage : [errorMessage])
            .filter(Boolean)
            .map((message, index) => (
              <div className='alert alert-danger payment-error' role='alert' key={index}>
                {message}
                {onRetryPrice && (
                  <button type='button' className='payment-error__retry' onClick={onRetryPrice}>
                    {t("try_again", "Try again")}
                  </button>
                )}
              </div>
            ))}
        </>
      )}
    </>
  );
};

export default StepTwoComponent;
